<script setup>
import { ref } from 'vue';
import { useAlert } from 'dashboard/composables';
import { ContractsAPI } from 'dashboard/api/talkviaContracts';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({ contract: { type: Object, required: true } });
const emit = defineEmits(['updated']);
const loading = ref(false);
const copy = {
  title: 'Pendência de estoque',
  description:
    'A assinatura foi preservada. Falta saldo para baixar os itens de consumo na entrega.',
  missing: 'faltam',
  instruction: 'Regularize o saldo no estoque e tente a baixa novamente.',
};
const retry = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const { data } = await ContractsAPI.retryStock(props.contract.id);
    emit('updated', data);
    useAlert(
      data.metadata?.stock_pending
        ? 'O estoque ainda é insuficiente. Confira as quantidades pendentes.'
        : 'Baixa de estoque regularizada.'
    );
  } catch {
    useAlert('Não foi possível conferir o estoque. Tente novamente.');
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <details
    v-if="contract.metadata?.stock_pending"
    class="max-w-64 rounded-md bg-n-amber-3 p-2 text-xs text-n-amber-11"
  >
    <summary class="cursor-pointer font-semibold">{{ copy.title }}</summary>
    <p class="my-2">
      {{ copy.description }}
    </p>
    <ul class="grid gap-1">
      <li
        v-for="item in contract.metadata.stock_pending.items"
        :key="item.product_id"
      >
        {{ item.product_name }}: {{ copy.missing }}
        {{ Number(item.missing).toLocaleString('pt-BR') }}.
      </li>
    </ul>
    <p class="my-2">{{ copy.instruction }}</p>
    <Button
      v-if="['signed', 'awaiting_delivery'].includes(contract.status)"
      label="Tentar baixa novamente"
      size="sm"
      variant="outline"
      :is-loading="loading"
      @click="retry"
    />
  </details>
</template>
